import { useContext } from 'react';
import SectionContext from '../../../SectionContext';
import SectionContentGroupContext from '../../../SectionContentGroupContext';
import FieldContext from '../../FieldContext';
import ContentGroupType from '@/lib/constants/challengeModel/ContentGroupType.enum';

const usePossibleMovesState = (): [boolean, boolean] => {
  const { previousSection, nextSection } = useContext(SectionContext);
  const currentSectionContentGroup = useContext(SectionContentGroupContext);
  const { previousField, nextField } = useContext(FieldContext);

  const moveUpImpossible =
    currentSectionContentGroup !== ContentGroupType.BOTTOM &&
    !previousSection &&
    !previousField;

  const moveDownImpossible =
    currentSectionContentGroup === ContentGroupType.BOTTOM &&
    !nextSection &&
    !nextField;

  const canMoveUp = !moveUpImpossible;
  const canMoveDown = !moveDownImpossible;

  return [canMoveUp, canMoveDown];
};

export default usePossibleMovesState;
